import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connectToStores} from 'fluxible-addons-react';
import {login} from '../../../actions/AuthenticationActionCreators';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router';
import {defineMessages, FormattedMessage, intlShape} from 'react-intl';
import AccountMessages from './AccountMessages';
import CommonMessages from '../../../intl/CommonMessages';
import Actions from '../../../constants/Actions';

const messages = defineMessages({
  welcome: {
    id: 'home.welcome',
    defaultMessage: 'Welcome to the Ignite Sales Customer Portal',
    description: 'A welcome message for the user when they visit the home page.'
  }
});

//TODO: Make a generic form component.
@connectToStores(['AuthenticationStore'], (context) => {
  const AuthenticationStore = context.getStore('AuthenticationStore');

  return {
    authenticationFailed: AuthenticationStore.didAuthenticationFail() || false
  };
})
class Login extends Component {

  static propTypes = {
    authenticationFailed: PropTypes.bool.isRequired,
    emailAddress: PropTypes.string,
    password: PropTypes.string,
    location: PropTypes.object.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      emailAddress: '',
      password: '',
      rememberMe: true
    };
  }

  static async loadAction(context) {
    context.dispatch(Actions.AUTHENTICATION_CLEAR_FORM_STATE, {});
  }

  processLogin = e => {
    e.preventDefault();

    console.log('User login clicked', this.state);
    const {executeAction} = this.context;
    const {location} = this.props;
    const {emailAddress} = this.state;
    const payload = {
      ...this.state,
      emailAddress: emailAddress.toLowerCase()
    };

    if (location.query && location.query.redirect) {
      payload.redirect = location.query.redirect;
    }

    executeAction(login, payload);
  };

  handleEmailChange = e => {
    const value = e.target.value;
    this.setState({
      emailAddress: value
    });
  };

  handlePasswordChange = e => {
    const value = e.target.value;
    this.setState({
      password: value
    });
  };

  handleRememberMe = e => {
    const value = e.target.checked;
    this.setState({
      rememberMe: value
    });
  };

  render() {
    const intl = this.context.intl;
    const emailAddressText = intl.formatMessage(AccountMessages.emailAddress);
    const passwordText = intl.formatMessage(AccountMessages.password);
    const {authenticationFailed} = this.props;

    const {rememberMe} = this.state;
    const linkQuery = this.state.emailAddress ? `?emailAddress=${this.state.emailAddress}`: '';

    const alert = authenticationFailed ? <div className="alert alert-danger" role="alert">
      <FormattedMessage { ...AccountMessages.loginFailed } />
    </div> : null;

    const rememberIconName = rememberMe ? 'check-square' : 'square';
    return <div className="home flex-element flex-container flex-vertical">
      <section className="user-info flex-center">
      <h1>
        <FormattedMessage { ...messages.welcome } />
      </h1>
      <div className="login-container">
        <div className="card">
          <div className="card-body">
            <h2 className="card-title">
              <FormattedMessage { ...AccountMessages.loginHeader } />
            </h2>
            <h4 className="card-subtitle text-muted">
              <FormattedMessage { ...AccountMessages.loginPrompt } />
            </h4>
          </div>
          <div className="card-body">
            {alert}
            <form className="login"
                  onSubmit={this.processLogin}>
              <fieldset className="form-group">
                <label className="sr-only" htmlFor="emailAddress">
                  { emailAddressText }
                </label>
                <div className="input-group">
                  <input type="email"
                         className="form-control form-control-success form-control-error"
                         name="emailAddress"
                         onChange={this.handleEmailChange}
                         value={this.state.emailAddress}
                         placeholder={ emailAddressText } />
                  <div className="input-group-append">
                    <span className="input-group-text"><FontAwesome name="envelope" /></span>
                  </div>
                </div>
              </fieldset>
              <fieldset className="form-group">
                <label className="sr-only" htmlFor="password">
                  { passwordText }
                </label>
                <div className="input-group">
                  <input type="password"
                         className="form-control"
                         name="password"
                         onChange={this.handlePasswordChange}
                         value={this.state.password}
                         placeholder={ passwordText } />
                  <div className="input-group-append">
                    <span className="input-group-text"><FontAwesome name="lock" /></span>
                  </div>
                </div>

                <Link to={`/account/forgot${linkQuery}`}>
                  Forgot your password?
                </Link>
              </fieldset>
              <div className="form-group">
                <label htmlFor="rememberMe" className="custom-control custom-checkbox">
                  <input type="checkbox"
                         className="custom-control-input"
                         id="rememberMe"
                         name="rememberMe"
                         onChange={this.handleRememberMe}
                         checked={this.state.rememberMe} />
                <span className="indicator">
                  <FontAwesome name={ rememberIconName } />
                </span>
                <span className="custom-control-description">
                  Remember me?
                </span>
                </label>
              </div>
              <button className="btn btn-primary" type="submit">
                <FormattedMessage { ...CommonMessages.submit } />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    </div>;
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/apps/Account/components/Login.js